import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import { formatDateDataGrid } from "src/utils/format-date"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaEventosConciliacaoTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }

    const createRow = async () => {
        const body = {
            RendaFixaCaracteristicasID: null,
            IDEvento: 0,
            DataEventoConciliacao: dayjs().format(DATE_FORMAT),
            ValorEventoConciliacao: 0,
            Observacao: "N/A"
        }

        props.loading(true)

        return datalakeService
            .createTableEndpoint(props.endpoint, body)
            .then(() => loadData())
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            RendaFixaCaracteristicasID,
            IDEvento,
            DataEventoConciliacao,
            ValorEventoConciliacao,
            Observacao
        } = newRow

        const body = {
            RendaFixaCaracteristicasID,
            IDEvento,
            DataEventoConciliacao,
            ValorEventoConciliacao,
            Observacao
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const deleteRow = async (row) => {
        const { ID } = row
        props.loading(true)

        return datalakeService
            .deleteTableEndpoint(props.endpoint, ID)
            .then(() => {
                setData(data.filter((item) => item.ID !== ID))
            })
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            minWidth: 80,
            disableColumnMenu: true,
            disableFilter: true
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            minWidth: 220,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'IDEvento',
            headerName: 'IDEvento',
            minWidth: 150,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'DataEventoConciliacao',
            headerName: 'DataEventoConciliacao',
            minWidth: 200,
            typeComponent: 'date',
            editable: true,
            disableColumnMenu: true,
            renderCell: (params) =>
                params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        {
            field: 'ValorEventoConciliacao',
            headerName: 'ValorEventoConciliacao',
            minWidth: 200,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'Observacao',
            headerName: 'Observacao',
            minWidth: 300,
            editable: true,
            disableColumnMenu: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableFilter: true,
            disableColumnMenu: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            createRow={createRow}
            updateRow={updateRow}
            deleteRow={deleteRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter
        />
    )
}

ParameterEmissaoRendaFixaEventosConciliacaoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaEventosConciliacaoTable
